import { supabase } from './supabase'

export interface InviteUserParams {
  email: string
  role: string
  companyName?: string
  eoriNumbers?: string[]
}

// Goes through the ADMIN-gated invite-user edge function; the browser never holds a service key.
export async function inviteUser(params: InviteUserParams): Promise<{ error: string | null }> {
  const { data, error } = await supabase.functions.invoke('invite-user', { body: params })
  if (error) {
    // FunctionsHttpError carries the response; surface our { error } message when present.
    const detail = await (error as { context?: Response }).context?.json?.().catch(() => null)
    return { error: friendlyInviteError(detail?.error) }
  }
  return { error: data?.error ? friendlyInviteError(data.error) : null }
}

// Staff should never see raw HTTP statuses or SDK wording.
function friendlyInviteError(raw?: string): string {
  const msg = raw ?? ''
  if (/already (been )?registered|already exists/i.test(msg)) return 'This person already has an account.'
  if (/rate limit/i.test(msg)) return 'Too many invitations sent recently. Please wait a few minutes and try again.'
  if (/Only ADMIN/i.test(msg)) return 'Only administrators can invite users.'
  if (/Invalid email/i.test(msg)) return 'That email address does not look valid.'
  if (/Invalid role/i.test(msg)) return 'Please select a valid role.'
  if (/Not authenticated/i.test(msg)) return 'Your session has expired. Please sign in again.'
  return 'Could not send the invitation. Please try again, or contact support if it keeps happening.'
}
